/* Refresh installed product labels without calling an absent app method. */
(() => {
  'use strict';
  if (window.mrProductLabelRefresh) return;
  window.mrProductLabelRefresh = true;
  let timer;
  const refresh = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      const labels = window.SECOMAPP?.pl;
      if (typeof labels?.labelCollections === 'function') labels.labelCollections(true);
    }, 1000);
  };
  ['pushState', 'replaceState'].forEach(method => {
    const original = history[method];
    history[method] = function () {
      const result = original.apply(this, arguments);
      window.dispatchEvent(new Event(method === 'pushState' ? 'pushstate' : 'replacestate'));
      window.dispatchEvent(new Event('locationchange'));
      return result;
    };
  });
  window.addEventListener('popstate', () => window.dispatchEvent(new Event('locationchange')));
  window.addEventListener('locationchange', refresh);
  if (document.readyState === 'complete') refresh();
  else window.addEventListener('load', refresh, { once: true });
})();
